import dayjs from 'dayjs';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const isToday = (date: Date | string) => {
  return dayjs().isSame(dayjs(date), 'date');
};

export const formatDate = (
  value: Date | string,
  formatting: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }
) => {
  if (!value) return value;

  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value));
};

// Returns short month of passed date
export const formatDateToMonthShort = (
  value: Date | string,
  toTimeForCurrentDay = true
) => {
  const date = new Date(value);
  let formatting: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
  };

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: 'numeric', minute: 'numeric' };
  }

  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value));
};

export const getDateRange = (startDate: Date, endDate: Date) => {
  const days = dayjs(endDate).diff(startDate, 'day');

  return [...Array(days + 1).keys()].map((i) =>
    dayjs(startDate).add(i, 'day').format('dd/MM/yyyy')
  );
};

export const dateFormat = (date: string) => {
  return dayjs(date).format('YYYY-MM-DD');
};
